import React, {Component} from 'react';
import {connect} from 'react-redux';
import NotMatchedPlayers from './not-matched-players';
import AvailablePlayers from './available-players';
import MatchedPlayers from './matched-players';
import {getPropValues} from 'helpers/array-helper';
import {generateRandomKey} from 'helpers/hash';
import {Match} from './match';
import Const from 'const';
import Action from 'actions';

interface Props {
    csvPlayers: object[];
    matchedPlayerNameSlugs: string[];
    onConfirm: (matches: Match[]) => void;
    onCancel: () => void;
    dispatch;
}

interface State {
    matches: {[key: string]: Match};
    isMatchValid: boolean;
}

class MatchPlayers extends Component<Props, State> {
    private match = Match.init();
    constructor(props) {
        super(props);
        this.state = {matches: {}, isMatchValid: this.match.isValid()};
    }
    onChooseSourcePlayer(csvPlayer): void {
        this.match.sourcePlayer = csvPlayer;
        this.setState({isMatchValid: this.match.isValid()});
    }
    onChooseTargetPlayer(player): void {
        this.match.targetPlayerId = player.getId();
        this.setState({isMatchValid: this.match.isValid()});
    }
    onMatch(): void {
        if (!this.match.isValid()) {
            return;
        }

        const {matches} = this.state;
        matches[generateRandomKey()] = this.match;

        this.match = Match.init();
        this.setState({matches, isMatchValid: this.match.isValid()});
    }
    onCancel(): void {
        this.props.dispatch(Action.do('closeModal'));
        this.props.onCancel();
    }
    onConfirm(): void {
        this.props.dispatch(Action.do('closeModal'));
        this.props.onConfirm(Object.values(this.state.matches));
    }
    onRemoveMatchedPlayers(matchedPlayersKey: string): void {
        const {matches} = this.state;
        delete matches[matchedPlayersKey];

        this.setState({matches});
    }
    getCsvPlayers(): object[] {
        const {csvPlayers} = this.props;
        const {matches} = this.state;

        if (isEmpty(matches)) {
            return csvPlayers;
        }

        const matchedCsvPlayerNameSlugs = getPropValues(matches, 'sourcePlayer').map((item) => item.nameSlug);
        // @ts-ignore
        return csvPlayers.filter((item) => !inArray(item.nameSlug, matchedCsvPlayerNameSlugs));
    }
    getMatchedPlayerIds(): string[] {
        const {matches} = this.state;

        return getPropValues(matches, 'targetPlayerId');
    }
    render() {
        const {matchedPlayerNameSlugs} = this.props;

        return (
            <>
                <span className="alert text-center mb0">{Const.CSV_PLAYERS_NOT_MATCHED_MESSAGE}</span>
                <div className="match-container">
                    <div className="match-block">
                        <NotMatchedPlayers
                            onChoosePlayer={this.onChooseSourcePlayer.bind(this)}
                            csvPlayers={this.getCsvPlayers()}
                        />
                    </div>
                    <button
                        type="button"
                        disabled={!this.state.isMatchValid}
                        onClick={this.onMatch.bind(this)}
                        className="btn"
                    >
                        Match
                    </button>
                    <div className="match-block">
                        <AvailablePlayers
                            onChoosePlayer={this.onChooseTargetPlayer.bind(this)}
                            matchedPlayerNameSlugs={matchedPlayerNameSlugs}
                            matchedPlayerIds={this.getMatchedPlayerIds()}
                        />
                    </div>
                </div>
                <MatchedPlayers onRemove={this.onRemoveMatchedPlayers.bind(this)} matches={this.state.matches} />
                <div className="modal-actions">
                    <button type="button" onClick={this.onCancel.bind(this)} className="btn btn-gray">
                        Cancel
                    </button>
                    <button type="button" autoFocus onClick={this.onConfirm.bind(this)} className="btn">
                        Ok
                    </button>
                </div>
            </>
        );
    }
}

export default connect(() => ({}))(MatchPlayers);
